<template>
  <v-row no-gutters>
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>

    <dialog-company
      :dialog="dialogCompany"
      :company="selectedCompany"
      v-on:dialog-close="onDialogClose"
    ></dialog-company>

    <!-- Company Rate -->
    <dialog-company-rates
      :dialog="dialogCompanyRates"
      :company_rate="selectedCompanyRates"
      v-on:dialog-close="onDialogClose"
    ></dialog-company-rates>

    <!-- warning dialog -->
    <!-- <v-dialog v-model="dialogXeroSyncConfirm" max-width="600px">
      <v-card>
        <v-card-title class="headline">Attention!!!</v-card-title>
        <v-card-text>
          <v-alert outlined type="warning" prominent border="left">
            <v-row no-gutters>
              <v-col>
                <v-row class="mb-2"
                  >Are you sure you want sync this company with Xero?</v-row
                >
                <v-row v-if="selectedXeroCompany != null" no-gutters>
                  <v-col cols="4">
                    <span>Company name:</span>
                  </v-col>
                  <v-col>
                    <span>{{ selectedXeroCompany.name }}</span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-row justify="center">
            <v-btn
              v-if="selectedXeroCompany != null"
              class="mx-7 font-weight-bold"
              color="primary"
              outlined
              @click="onConfirmxeroSync"
              >SYNC</v-btn
            >
            <v-btn
              class="mx-7 font-weight-bold"
              color="error"
              outlined
              dark
              @click="ondialogXeroSyncConfirmClose"
              >NO</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog> -->

    <v-row no-gutters>
      <v-col>
        <v-toolbar flat class="sub-toolbar" height="50px">
          <v-row no-gutters>
            <v-col cols="5">
              <v-row>
                <v-icon class="mr-2" color="primary" size="30"
                  >mdi-domain</v-icon
                >
                <v-toolbar-title class="primary--text"
                  >Companies</v-toolbar-title
                >
              </v-row>
            </v-col>

            <v-col cols="4" class="d-flex justify-center">
              <input
                class="form-control"
                v-model="companySearch"
                placeholder="Search table either by tags or name or country"
              />
            </v-col>

            <v-spacer></v-spacer>

            <v-col class="d-flex justify-content-end">
              <v-btn small outlined color="primary" @click="onNewCompany()">
                <v-icon>add</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-toolbar>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col class="px-2">
        <v-card flat color="white">
          <v-data-table
            dense
            :search="companySearch"
            :headers="companyHeader"
            :items="sortedCompanies"
            :footer-props="{
              itemsPerPageOptions: [20, 30, 40, 50, -1],
            }"
          >
            <template v-slot:item="{ item }">
              <tr :key="item.company_id">
                <td class="text-left">{{ item.company_id }}</td>
                <td class="text-left">{{ item.name }}</td>
                <td class="text-left overline text-lowercase">
                  {{ item.tags.join(", ") }}
                </td>
                <td class="text-left caption text-capitalize">
                  {{ item.address.country }}
                </td>
                <!-- <td class="text-center">
                  <v-tooltip right>
                    <template v-slot:activator="{ on }">
                      <img v-on="on" :src="getFlag(item.address.code_country)" class="country-flag" />
                    </template>
                    {{item.address.country}}
                  </v-tooltip>
                </td>-->
                <td class="text-center">{{ item.preferred_currency }}</td>
                <td class="text-center overline">
                  {{ item.customer_rank_label }}
                </td>
                <td class="text-center">{{ item.registration_number }}</td>
                <td class="text-center column-icon">
                  <v-icon v-if="item.xero_sync" color="#7FB800"
                    >fa-check-circle</v-icon
                  >
                  <v-icon v-else color="#8F2D56">fa-times-circle</v-icon>
                </td>
                <td class="text-center column-icon">
                  <v-icon v-if="item.approved" color="#7FB800"
                    >fa-check-circle</v-icon
                  >
                  <v-icon v-else color="#8F2D56">fa-times-circle</v-icon>
                </td>
                <td class="text-center column-icon">
                  <v-icon v-if="item.allow_access" color="#7FB800"
                    >fa-check-circle</v-icon
                  >
                  <v-icon v-else color="#8F2D56">fa-times-circle</v-icon>
                </td>
                <td class="text-center">{{ item.updated.substring(0, 10) }}</td>
                <td class="justify-center px-0">
                  <v-menu
                    bottom
                    origin="center center"
                    transition="scale-transition"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" color="primary" icon small dark>
                        <v-icon>menu</v-icon>
                      </v-btn>
                    </template>

                    <v-list dense>
                      <v-list-item
                        v-for="(menuItem, i) in onMenuOptions(item)"
                        :key="i"
                        @click="onSelectedMenu(menuItem, item)"
                      >
                        <v-list-item-action class="mr-2">
                          <v-icon size="20" :color="menuItem.color">{{
                            menuItem.icon
                          }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>{{
                            menuItem.title
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-row>
</template>


<script>
import constant from "../../const"

export default {
  data() {
    return {
      CONSTANTS: constant,

      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 8000,

      alert: false,
      alertMessage: "",
      alertType: "success",
      dialogCompany: false,
      dialogCompanyRates: false,
      // dialogXeroSyncConfirm: false,
      // selectedXeroCompany: null,
      selectedCompany: null,
      selectedCompanyRates: null,
      companySearch: "",

      companies: [],
      selectedCompanySync: {},
      isCompanyEdited: false,
      isCompanyCreated: false,

      companyHeader: [
        {
          text: "ID",
          align: "left",
          description: "Company ID",
          showTooltip: true,
          value: "count_id",
        },
        {
          text: "Name",
          align: "left",
          description: "Company name",
          showTooltip: true,
          value: "name",
        },
        {
          text: "Tags",
          align: "left",
          description: "Tags",
          showTooltip: true,
          value: "tags",
        },
        {
          text: "Country",
          align: "left",
          description: "Company country",
          showTooltip: true,
          value: "country",
        },
        {
          text: "Currency",
          align: "left",
          description: "Company preferred currency",
          showTooltip: true,
          value: "preferred_currency",
        },
        {
          text: "Rank",
          align: "left",
          description: "Profile rank (customers only)",
          showTooltip: true,
          value: "customer_rank_label",
        },
        {
          text: "Reg. no",
          align: "left",
          description: "Company registration number",
          showTooltip: true,
          value: "registration_number",
        },
        {
          text: "Xero Sync",
          align: "left",
          description: "Xero Sync",
          showTooltip: true,
          value: "xero_sync",
        },
        {
          text: "Approved",
          align: "left",
          description: "Registration approved",
          showTooltip: true,
          value: "approved",
        },
        {
          text: "Access",
          align: "left",
          description: "Access allowed",
          showTooltip: true,
          value: "allow_access",
        },
        {
          text: "Updated",
          align: "left",
          description: "Updated",
          showTooltip: true,
          value: "updated",
        },
        {
          text: "Actions",
          align: "center",
          description: "",
          showTooltip: false,
          value: "action",
          sortable: false,
        },
      ],
    }
  },

  async created() {
    // verify user token
    await this.$root.verify_user_token()
  },

  mounted() {
    this.loadCompanyList()
  },

  methods: {
    /**
     * menu option list
     */
    onMenuOptions(item) {
      var menu = [
        {
          id: "edit",
          icon: "mdi-pencil",
          color: "primary",
          title: "Edit",
          show: true,
        },
        // {
        //   id: "sync",
        //   icon: "mdi-sync",
        //   color: "primary",
        //   title: "Xero sync",
        //   show: !item.xero_sync
        // },
        {
          id: "rates",
          icon: "mdi-currency-usd",
          color: "primary",
          title: "Company rates",
          show: true,
        },
        {
          id: "delete",
          icon: "mdi-delete",
          color: "error",
          title: "Trash company",
          show: true,
        },
      ]
      return menu
    },

    /**
     * On selecting a menu item
     */
    onSelectedMenu: function (menuItem, account) {
      switch (menuItem.id) {
        case "edit":
          this.onEditCompany(account)
          break
        // case "sync":
        //   this.onXeroSync(account)
        //   break
        case "rates":
          this.onPricingRates(account)
          break
        case "delete":
          this.onDelete(account)
          break
      }
    },

    getFlag(flagName) {
      try {
        return require(`@/assets/flags/4x3/${flagName.toLowerCase()}.svg`)
      } catch (e) {
        return require("@/assets/flags/4x3/undefined.svg")
      }
    },

    loadCompanyList: function () {
      // load the blockui
      this.$root.blockUImsg = "Loading companies..."
      this.$root.blockUIshow = true
      this.$https
        .get("/api/company/list")
        .then((resp) => {
          if (resp.data.status == constant.RESPONSE_STATUS_OK) {
            this.companies = resp.data.data
          } else {
            this.companies = []
            this.showSnackbar = true
            this.snackbarColor = "error"
            this.snackbarMsg = resp.data.msg
          }
          this.$root.blockUIshow = false
        })
        .catch((err) => {
          console.log(err)
          this.$root.blockUIshow = false
        })
    },

    onNewCompany() {
      this.isCompanyCreated = true
      this.isCompanyEdited = false
      this.dialogCompany = true
    },

    onEditCompany: function (company) {
      this.$root.blockUImsg = "Loading..."
      this.$root.blockUIshow = true
      this.$https
        .get("/api/company/" + company.company_id)
        .then((resp) => {
          if (resp.data.status == constant.RESPONSE_STATUS_OK) {
            // clone the selected company
            this.selectedCompanySync = company

            this.isCompanyEdited = true
            this.isCompanyCreated = false

            this.selectedCompany = resp.data.data
            this.dialogCompany = true
          } else {
            this.showSnackbar = true
            this.snackbarColor = "error"
            this.snackbarMsg = resp.data.msg
          }
        })
        .catch((err) => {
          this.showSnackbar = true
          this.snackbarColor = "error"
          this.snackbarMsg = err
        })
        .finally(() => {
          this.$root.blockUIshow = false
        })
    },

    // onXeroSync: function (company) {
    //   this.dialogXeroSyncConfirm = true
    //   this.selectedXeroCompany = company
    // },

    // ondialogXeroSyncConfirmClose() {
    //   this.dialogXeroSyncConfirm = false
    //   this.selectedXeroCompany = null
    // },

    // onConfirmxeroSync() {
    //   this.$root.blockUImsg = "Syncing with Xero..."
    //   this.$root.blockUIshow = true
    //   this.$https
    //     .put(`api/company/xero/insert/${this.selectedXeroCompany.company_id}`)
    //     .then((resp) => {
    //       if (resp.data.status == constant.RESPONSE_STATUS_OK) {
    //         this.dialogXeroSyncConfirm = false
    //         this.showSnackbar = true
    //         this.snackbarColor = "success"
    //         this.snackbarMsg = resp.data.msg
    //         this.loadCompanyList()
    //       } else {
    //         this.showSnackbar = true
    //         this.snackbarColor = "error"
    //         this.snackbarMsg = resp.data.msg
    //       }
    //     })
    //     .catch((err) => {
    //       this.showSnackbar = true
    //       this.snackbarColor = "error"
    //       this.snackbarMsg = err
    //     })
    //     .finally(() => {
    //       this.$root.blockUIshow = false
    //     })
    // },

    /**
     * Customer / Supplier Rate management
     */
    onPricingRates: function (company) {
      this.$root.blockUImsg = "Loading company rates..."
      this.$root.blockUIshow = true

      this.selectedCompanyRates = null

      this.$https
        .get(`/api/company/rates/${company.company_id}`)
        .then((resp) => {
          if (resp.data.status == constant.RESPONSE_STATUS_OK) {
            this.dialogCompanyRates = true
            this.selectedCompanyRates = resp.data.data
          } else {
            this.showSnackbar = true
            this.snackbarColor = "error"
            this.snackbarMsg = resp.data.msg
          }
        })
        .catch((err) => {
          this.showSnackbar = true
          this.snackbarColor = "error"
          this.snackbarMsg = err
        })
        .finally(() => {
          this.$root.blockUIshow = false
        })
    },

    onDelete: function (company) {
      this.$root.blockUImsg = "Loading..."
      this.$root.blockUIshow = true

      this.$https
        .delete(`/api/company/${company.company_id}`)
        .then((resp) => {
          if (resp.data.status == constant.RESPONSE_STATUS_OK) {
            this.showSnackbar = true
            this.snackbarColor = "success"
            this.snackbarMsg = resp.data.msg
            // remove company
            this.companies = this.companies.filter(function (item) {
              return item != company
            })
          } else {
            this.showSnackbar = true
            this.snackbarColor = "error"
            this.snackbarMsg = resp.data.msg
          }
        })
        .catch((err) => {
          this.showSnackbar = true
          this.snackbarColor = "error"
          this.snackbarMsg = err
        })
        .finally(() => {
          this.$root.blockUIshow = true
        })
    },

    onDialogClose: function (dialog, hasChange, company) {
      switch (dialog) {
        case constant.DIALOG_COMPANY:
          this.dialogCompany = false
          // sync only if hasChange is true and this is from company edit
          if (hasChange && this.isCompanyEdited) {
            // sync the updated company
            this.selectedCompanySync = Object.assign(
              this.selectedCompanySync,
              company
            )
          } else if (hasChange && this.isCompanyCreated) {
            // append new company
            this.company.push(company)
          }
          break
        case constant.DIALOG_COMPANY_RATES:
          this.dialogCompanyRates = false
        default:
          break
      }

      this.selectedCompany = null
      this.selectedCompanyRates = null
    },
  },

  computed: {
    sortedCompanies: function () {
      return this.companies.sort(function (a, b) {
        return a.count_id - b.count_id
      })
    },
  },
}
</script>

<style>
.country-flag {
  max-width: 25px;
  margin-right: 10px;
  border: 1px solid #eaecf0;
}

/* .column-icon .v-icon {
  font-size: 18px;
} */
</style>
